
import { apiCall } from './apiCall';
  
  
  
export default function resellertypeApi() {
  return {
    getResellerTypeList: (data,token) => apiCall('/getAllResellerRegion',data, token,'GET'),
    changeRegion: (data,token) => apiCall('/changeRegion',data, token),
    getCurrentRegion: (data,token) => apiCall('/getCurrentRegion',data, token,'GET'),
    getResellerType: (data,token) => apiCall('/regions-for-registration',data, token,'GET'),
    getDocumentTypesByRegionId: (data,token) => apiCall('/getDocumentTypesByRegionId',data, token),
    
  };
}
